function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3814 22.0409L19.3711 18.1201L19.2771 17.9772C19.1023 17.8032 18.8634 17.7052 18.6139 17.7052C18.3645 17.7052 18.1256 17.8032 17.9508 17.9772C14.5427 21.1039 9.29109 21.2738 5.67893 18.3743C2.06676 15.4748 1.21487 10.4056 3.68822 6.52853C6.16157 2.65146 11.1927 1.16965 15.4449 3.06582C19.6972 4.96199 21.851 9.64775 20.4781 14.0155C20.3792 14.3311 20.4601 14.6742 20.6901 14.9157C20.9202 15.1572 21.2645 15.2603 21.5935 15.1863C21.9224 15.1122 22.186 14.8722 22.2848 14.5567C23.926 9.37341 21.4473 3.79547 16.4521 1.43123C11.4568 -0.933017 5.44423 0.625956 2.30382 5.09965C-0.836599 9.57334 -0.162372 15.6192 3.89034 19.3261C7.94305 23.033 14.158 23.2885 18.5147 19.9274L22.0655 23.3989C22.4322 23.7559 23.0251 23.7559 23.3918 23.3989C23.7582 23.0369 23.7582 22.454 23.3918 22.092L23.3814 22.0409Z",
  fill: "currentColor"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.dea4529c.svg";
export { ForwardRef as ReactComponent };